import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { Order } from '@spartacus/order/root'

export * from './occ-mb-order-normalizer'
export * from './occ-mb-payment-order.normalizer'

export const PAYMENT_ORDER_NORMALIZER = new InjectionToken<Converter<any, Order>>(
  'OccMbPaymentOrderNormalizer'
)
